import {call, put, takeLatest} from "redux-saga/effects";
import {API} from "../../../api/api";
import {SystemServerVersionsActionTypes} from "../actions/actionTypes";
import {SystemServerVersionsAPI} from "../api/api";
import {ToasterService} from "../../../services/toaster/toaster.service";

function* toggleSystemServerVersionStatus(action) {
    const systemServerVersionId = action.payload.systemServerVersionId;
    try {
        const status = yield call(() => SystemServerVersionsAPI.toggleSystemServerVersionStatus(systemServerVersionId));

        if (status.status == 202) {
            yield put({
                type: SystemServerVersionsActionTypes.TOGGLE_SYSTEM_SERVER_VERSION_SUCCESS,
                payload: {
                    systemServerVersionId: systemServerVersionId
                }
            });
        } else {
            ToasterService.errorToast("Error changing system server version status.");
        }
    } catch (e) {
        API.handleError(e.response, "Error changing system server version status.");

        yield put({
            type: SystemServerVersionsActionTypes.TOGGLE_SYSTEM_SERVER_VERSION_FAIL,
            message: e.message
        });
    }
}

export function* togglePresetActiveStateWatcher() {
    yield takeLatest(
        SystemServerVersionsActionTypes.TOGGLE_SYSTEM_SERVER_VERSION_STATUS,
        toggleSystemServerVersionStatus
    );
}